export default {
    indexEventCalendarBases: { method: 'get',    url: 'event_calendar_bases' },
    storeEventCalendarBase: { method: 'post',   url: 'event_calendar_bases'},
    updateEventCalendarBase: { method: 'put',    url: 'event_calendar_bases/{id}'},
    deleteEventCalendarBase: { method: 'delete', url: 'event_calendar_bases/{id}'}
}